module.exports = __webpack_public_path__ + "img/contact_phone.0746132b.svg";